import * as tslib_1 from "tslib";
import { OnInit, EventEmitter, TemplateRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SharedService } from '../../shared/shared.service';
import { ToasterService } from 'src/app/toaster.service';
import { Toaster, ToasterType } from 'src/app/shared/types/toaster.types';
import * as moment from 'moment';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LoaderService } from 'src/app/loader.service';
import { environment } from 'src/environments/environment';
import { ViewIncentivesService } from 'src/app/view-incentives/view-incentives.service';
import { MatDialog } from '@angular/material/dialog';
import { INCENTIVE_VERSION_V1, INCENTIVE_VERSION_V2, isLogisticsV2Version, resolveIncentiveVersionFromApi, } from '../quality-conditions.model';
import { attachMicroCorridorDisplayLabels, formatMicroCorridorOptionLabel, parseMicroCorridorsApiResponse, resolveModeIdForMcListing, resolveServiceDetailIdsForMcListing, resolveServiceDetailIdsFromSelection, resolveGlobalServiceIdsFromSelection, isLogisticsV2IncentiveTypeAllowed, } from '../mc-incentive.model';
import { formatLogisticsV2AllowedIncentiveTypes, isLogisticsV2CreateUiEnabledForServices, isLogisticsV2FeatureEnabled, resolveLogisticsV2IncentiveConfig, } from '../logistics-v2-incentive.config';
var BasicInfoComponent = /** @class */ (function () {
    function BasicInfoComponent(datePipe, sharedService, toasterService, loaderService, router, route, incentiveService, dialog) {
        this.datePipe = datePipe;
        this.sharedService = sharedService;
        this.toasterService = toasterService;
        this.loaderService = loaderService;
        this.router = router;
        this.route = route;
        this.incentiveService = incentiveService;
        this.dialog = dialog;
        this.header = 'Basic Info';
        this.incentiveType = this.sharedService.INCENTIVE_TYPES;
        this.serviceType = [];
        this.rules = [];
        this.ruleSelector = [];
        this.nextClicked = false;
        this.ruleObj = { city: false, service: false, shift: false };
        this.isCancellationLimitEnabledForCity = false;
        this.isMaxOrderDistanceEnabledForCity = false;
        this.adhocIncentiveNames = environment.adhocIncentiveNames;
        this.blockServicesForIncentiveCreation = new Set(environment.blockServicesForIncentiveCreation);
        this.adHocIncentive = false;
        this.selectedRuleUserCount = null;
        this.currentDate = new Date();
        this.errorPopupIncentives = [];
        this.segmentType = this.sharedService.SEGMENT_TYPES;
        this.selectedCity = "";
        this.selectedService = "";
        this.microCorridors = [];
        this.microCorridorsLoading = false;
        this.microCorridorsError = false;
        this.microCorridorsErrorMessage = '';
        this.microCorridorsEmptyMessage = 'No micro-corridors found for this city. Create one in supply or try another city.';
        this.microCorridorsModeMissingMessage = 'Could not resolve mode for selected services. Try re-selecting Type of service.';
        this.microCorridorsSelectCityMessage = 'Select a city to load micro-corridors.';
        this.incentiveVersionOptions = [
            { value: INCENTIVE_VERSION_V1, label: 'v1', note: 'legacy' },
            { value: INCENTIVE_VERSION_V2, label: 'v2', note: 'logistics' },
        ];
        this.payoutTypeOptions = ['Immediate', 'Deferred'];
        /** Shown on create/edit Basic Info — keep aligned with captain-incentive validation. */
        this.versionPayoutHelp = {
            title: 'Version & payout',
            intro: 'You are still on the standard (v1) create flow until you pick version below. v2 is offered only for services enabled in config.',
            v1: {
                heading: 'v1 (legacy)',
                types: 'Daily, Adhoc, Weekly Fixed, Weekly Selectable, Redeem',
                construct: 'Legacy goals: weekly APR/DPR quality; daily order/distance slabs (optional legacy quality on daily).',
                payout: 'Wallet credit on each qualifying order calculation. No payout type field on the API.',
            },
            v2: {
                heading: 'v2 (logistics)',
                types: '',
                construct: 'Logistics calc: ping metrics on slabs (qualityConditions). Use quality slab condition on the Goal step when slab and quality must pass together.',
                payoutImmediate: 'Same-day wallet credit when slabs qualify (progress calculation).',
                payoutDeferred: 'Progress during the day; wallet on the scheduled Final payout. On the Goal step, set payout policy Max day vs slots (day set + peak slot sets). MC sign-in incentives must use Deferred and micro-corridor assignment instead of a user selector.',
            },
            assignment: 'Captain targeting: choose a User selector or MC sign-in incentive — not both. HH incentives (v1 only) do not use a selector.',
            immutable: 'Version and payout type cannot be changed after create.',
        };
        this.NOT_EDITABLE = {
            incentiveName: false,
            incentiveDisplayName: false,
            selectedIncentive: false,
            selectedCity: false,
            selectedService: false,
            isHHIncentive: false,
            isMCIncentive: false,
            selectedMicroCorridorId: false,
            selectedShift: false,
            selectedRule: false,
            fromDate: false,
            toDate: false,
            priority: false,
            identifier: false,
            selectedSegment: false,
            incentiveVersion: false,
            payoutType: false,
        };
        this.basicInfo = new EventEmitter();
        this.basicInfoDataChange = new EventEmitter();
        this.incentiveDisplayNameFormControl = new FormControl(null, Validators.required);
        this.basicInfoFormGroup = new FormGroup({
            incentiveName: new FormControl('', Validators.required),
            incentiveDisplayName: this.incentiveDisplayNameFormControl,
            selectedIncentive: new FormControl(null, Validators.required),
            selectedCity: new FormControl(null, Validators.required),
            selectedService: new FormControl('', Validators.required),
            isHHIncentive: new FormControl(false, Validators.required),
            isMCIncentive: new FormControl(false, Validators.required),
            selectedMicroCorridorId: new FormControl(null),
            selectedShift: new FormControl([], Validators.required),
            selectedRule: new FormControl({ value: null, disabled: false }, Validators.required),
            fromDate: new FormControl('', Validators.required),
            toDate: new FormControl('', Validators.required),
            priority: new FormControl('', Validators.required),
            identifier: new FormControl('', Validators.required),
            selectedSegment: new FormControl(null, Validators.required),
            incentiveVersion: new FormControl(INCENTIVE_VERSION_V1, Validators.required),
            payoutType: new FormControl(null),
        });
    }
    BasicInfoComponent.prototype.isDisabled = function (disable) {
        return disable ? '' : null;
    };
    BasicInfoComponent.prototype.makeFieldsDisable = function () {
        var _this = this;
        // this.basicInfoFormGroup.get('incentiveName').disable()
        Object.keys(this.NOT_EDITABLE).forEach(function (fieldName) {
            var disable = _this.NOT_EDITABLE[fieldName];
            if (disable) {
                try {
                    _this.basicInfoFormGroup.get(fieldName).disable();
                }
                catch (err) { }
            }
        });
    };
    BasicInfoComponent.prototype.getMinEditableDate = function () {
        if (this.currentDate < this.minDate) {
            return this.minDate;
        }
        return this.currentDate;
    };
    BasicInfoComponent.prototype.patchDefaultValue = function (defaultValue) {
        var _this = this;
        this.loaderService.openLoading();
        var fieldValues = this.fetchSegmentNameAndIdentifierName(defaultValue.incentiveName);
        var incentiveVersion = resolveIncentiveVersionFromApi(defaultValue);
        this.basicInfoFormGroup.patchValue({
            incentiveName: fieldValues.incentiveName,
            selectedIncentive: defaultValue.incentiveType,
            fromDate: new Date(defaultValue.startDate),
            toDate: new Date(defaultValue.endDate),
            priority: defaultValue.priority,
            selectedSegment: fieldValues.segmentName,
            identifier: fieldValues.identifierName,
            incentiveVersion: incentiveVersion,
            payoutType: incentiveVersion === INCENTIVE_VERSION_V2
                ? (defaultValue.payoutType || 'Immediate')
                : null,
        });
        this.incentiveDisplayNameFormControl.patchValue(defaultValue.incentiveDisplayName || null);
        if (defaultValue.selectedVariable.indexOf("cancellation") != -1) {
            this.isCancellationLimitEnabledForCity = true;
        }
        if (defaultValue.selectedVariable.indexOf("maxOrderDistance") != -1) {
            this.isMaxOrderDistanceEnabledForCity = true;
        }
        if (defaultValue.tags) {
            this.basicInfoFormGroup.patchValue({
                isHHIncentive: defaultValue.tags.includes('HH'),
            });
        }
        if (isLogisticsV2Version(incentiveVersion)) {
            this.clearHHIncentiveForLogisticsV2();
        }
        var mcId = defaultValue.assignmentPolicy
            && defaultValue.assignmentPolicy.ids
            && defaultValue.assignmentPolicy.ids[0];
        if (mcId) {
            var mcName = defaultValue.assignmentPolicy && defaultValue.assignmentPolicy.name;
            this.basicInfoFormGroup.patchValue({
                isMCIncentive: true,
                selectedMicroCorridorId: String(mcId),
            });
            if (mcName != null && String(mcName).trim() !== '') {
                defaultValue.microCorridorName = String(mcName).trim();
            }
        }
        this.changeInDate();
        this.cityChangeCheck(defaultValue.cities[0], defaultValue.serviceType)
            .then(function () { return _this.getRules(); })
            .then(function () { return _this.ruleChangeCheck(defaultValue.ruleId); })
            .then(function () { return _this.loadMicroCorridorsAfterEditPrefill(); })
            .then(function () {
            var data = _this.formatData();
            _this.basicInfoDataChange.emit(data);
            _this.loaderService.closeLoading();
            // this.passBasicInfo();
        })
            .catch(function (err) {
            _this.loaderService.closeLoading();
        });
    };
    BasicInfoComponent.prototype.fetchSegmentNameAndIdentifierName = function (finalName) {
        var splitArray = finalName.split("_");
        var result = {
            segmentName: "",
            identifierName: "",
            incentiveName: ""
        };
        try {
            var segmentAndIncentiveName = splitArray[3];
            var segment = segmentAndIncentiveName.split(" ");
            if (splitArray[0] == "ALLOCATOR") { // Naming convention of iAllocator incentives -> ALLOCATOR_${ cityName }_${ segment.label }_${ shortStartDate }_${ shortEndDate }_${ incentiveType }
                var segment_1 = splitArray.slice(2, -3).join(' ');
                result.segmentName = segment_1;
                result.identifierName = "iAllocator";
                result.incentiveName = segment_1;
            }
            else if (splitArray[0] == "MANUAL" && segment && segment[0] == "CUSTOM") {
                result.segmentName = "CUSTOM";
                result.identifierName = splitArray[7];
                result.incentiveName = segmentAndIncentiveName.substr(7);
            }
            else if (splitArray[0] == "MANUAL") {
                result.segmentName = segmentAndIncentiveName;
                result.identifierName = splitArray[7];
                result.incentiveName = segmentAndIncentiveName;
            }
            else {
                result.segmentName = "CUSTOM";
                result.incentiveName = finalName;
                result.identifierName = "identifier";
            }
        }
        catch (err) {
            result.segmentName = "CUSTOM";
            result.incentiveName = finalName;
            result.identifierName = "identifier";
        }
        return result;
    };
    BasicInfoComponent.prototype.applyLaunchQueryPrefill = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var q, cityId, serviceId, city, matchedServices;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        q = (this.route.snapshot && this.route.snapshot.queryParams) || {};
                        cityId = (q['city'] || '').trim();
                        serviceId = (q['service'] || '').trim();
                        if (!cityId || !this.cities) {
                            return [2 /*return*/];
                        }
                        city = this.cities.find(function (c) { return String(c._id) === String(cityId); });
                        if (!city) {
                            this.errorMessage('City from launch URL is not available.');
                            return [2 /*return*/];
                        }
                        this.loaderService.openLoading();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        this.basicInfoFormGroup.patchValue({ selectedCity: city });
                        this.checkCityEnabledForCancellationLimit(city);
                        this.checkCityEnabledForMaxOrderDistance(city);
                        return [4 /*yield*/, this.onCityChange()];
                    case 2:
                        _a.sent();
                        if (!serviceId) {
                            return [2 /*return*/];
                        }
                        matchedServices = (this.services || []).filter(function (serviceDetail) { return serviceDetail
                            && serviceDetail.service
                            && String(serviceDetail.service._id) === String(serviceId); });
                        if (!matchedServices.length) {
                            this.errorMessage('Service from launch URL is not available for this city.');
                            return [2 /*return*/];
                        }
                        this.basicInfoFormGroup.patchValue({ selectedService: matchedServices });
                        this.serviceSelected();
                        this.checkRuleObj();
                        return [3 /*break*/, 4];
                    case 3:
                        this.loaderService.closeLoading();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BasicInfoComponent.prototype.cityChangeCheck = function (selectedCity, serviceTypeIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var city;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.cities) return [3 /*break*/, 2];
                        city = this.cities.find(function (city) { return city.displayName === selectedCity; });
                        this.basicInfoFormGroup.patchValue({
                            selectedCity: city,
                        });
                        this.checkCityEnabledForCancellationLimit(city);
                        this.checkCityEnabledForMaxOrderDistance(city);
                        return [4 /*yield*/, this.onCityChange({
                                skipMicroCorridorFetch: !!serviceTypeIds,
                                serviceTypeIdsToRestore: serviceTypeIds,
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BasicInfoComponent.prototype.ruleChangeCheck = function (selectedRuleId) {
        if (this.getValues('isHHIncentive')) {
            this.basicInfoFormGroup.get("selectedRule").disable();
            this.basicInfoFormGroup.patchValue({
                selectedRule: null,
            });
            return;
        }
        if (this.rules && this.rules.length) {
            var rule = this.ruleSelector.find(function (sel) { return sel._id === selectedRuleId; });
            if (rule && rule.name) {
                this.basicInfoFormGroup.patchValue({
                    selectedRule: rule.name,
                });
            }
        }
    };
    BasicInfoComponent.prototype.serviceChangeCheck = function (selectedServiceIds) {
        this.applyServiceSelectionFromIds(selectedServiceIds);
    };
    BasicInfoComponent.prototype.applyServiceSelectionFromIds = function (selectedServiceIds) {
        var _this = this;
        if (!selectedServiceIds || !this.services.length) {
            return;
        }
        var selectedServicesObject = [];
        selectedServiceIds.forEach(function (selectedServiceId) {
            var id = String(selectedServiceId);
            var service = _this.services.find(function (s) {
                return (s.service && String(s.service._id) === id) || String(s._id) === id;
            });
            if (service) {
                selectedServicesObject.push(service);
            }
        });
        if (selectedServicesObject.length === 0) {
            return;
        }
        this.basicInfoFormGroup.patchValue({
            selectedService: selectedServicesObject,
        });
        this.ruleObj['service'] = true;
    };
    BasicInfoComponent.prototype.shiftChangeCheck = function (selectedShifts) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var interval = setInterval(function () {
                if (_this.shifts.length) {
                    _this.basicInfoFormGroup.patchValue({
                        selectedShift: selectedShifts,
                    });
                    // const city = this.shifts.find(city => city.displayName === selectedCity);
                    // this.basicInfoFormGroup.patchValue({
                    //   selectedCity: city,
                    // });
                    // this.onCityChange();
                    clearInterval(interval);
                    return resolve({});
                }
            }, 100);
        });
    };
    BasicInfoComponent.prototype.compareCityFn = function (cityOne, cityTwo) {
        return cityOne.displayName === cityTwo.displayName;
    };
    BasicInfoComponent.prototype.compareServiceFn = function (serviceOne, serviceTwo) {
        return serviceOne._id === serviceTwo._id;
    };
    BasicInfoComponent.prototype.compareShiftFn = function (shiftOne, shiftTwo) {
        return shiftOne === shiftTwo;
    };
    BasicInfoComponent.prototype.compareRuleFn = function (shiftOne, shiftTwo) {
        return shiftOne === shiftTwo;
    };
    BasicInfoComponent.prototype.onCityChange = function (loadOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCityServices(this.basicInfoFormGroup.get('selectedCity'), loadOptions)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasicInfoComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.makeFieldsDisable();
                        return [4 /*yield*/, this.getCities()];
                    case 1:
                        _b.sent();
                        _a = this.state;
                        switch (_a) {
                            case this.sharedService.STATE.EDIT: return [3 /*break*/, 2];
                            case this.sharedService.STATE.DUPLICATE: return [3 /*break*/, 3];
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        {
                            this.patchDefaultValue(this.defaultValue);
                            this.incentiveTypeSelected();
                            return [3 /*break*/, 6];
                        }
                        _b.label = 3;
                    case 3:
                        {
                            this.patchDefaultValue(this.defaultValue);
                            this.incentiveTypeSelected();
                            return [3 /*break*/, 6];
                        }
                        _b.label = 4;
                    case 4: return [4 /*yield*/, this.applyLaunchQueryPrefill()];
                    case 5:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 6:
                        this.basicInfoFormGroup.get('selectedCity').valueChanges.subscribe(function (data) {
                            _this.checkCityEnabledForCancellationLimit(data);
                            _this.checkCityEnabledForMaxOrderDistance(data);
                            _this.basicInfoFormGroup.get('selectedRule').setValue(null);
                        });
                        this.basicInfoFormGroup.get('selectedService').valueChanges.subscribe(function (data) {
                            _this.basicInfoFormGroup.get('selectedRule').setValue(null);
                            _this.enforceLogisticsV2Eligibility();
                        });
                        this.basicInfoFormGroup.get('incentiveName').valueChanges.subscribe(function () {
                            _this.enforceLogisticsV2Eligibility();
                        });
                        this.basicInfoFormGroup.get('selectedIncentive').valueChanges.subscribe(function () {
                            _this.enforceLogisticsV2Eligibility();
                        });
                        this.basicInfoFormGroup.get('selectedShift').valueChanges.subscribe(function (data) {
                            _this.basicInfoFormGroup.get('selectedRule').setValue(null);
                        });
                        this.basicInfoFormGroup.get('selectedRule').valueChanges.subscribe(function (data) {
                            _this.ruleSelected();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    BasicInfoComponent.prototype.changeInDate = function () {
        if (this.getValues('fromDate')) {
            this.minDate = this.getValues('fromDate');
        }
        if (this.getValues('toDate')) {
            this.maxDate = this.getValues('toDate');
        }
    };
    BasicInfoComponent.prototype.getCities = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sharedService.fetchCities().toPromise().then(function (response) {
                            _this.cities = response['data'].cities;
                            _this.ruleObj['service'] = false;
                            _this.ruleObj['shift'] = false;
                            _this.ruleObj['city'] = true;
                            for (var index in _this.cities) {
                                if (_this.cities[index].displayName === 'All') {
                                    _this.cities.splice(index, 1);
                                }
                            }
                        }, function (error) {
                            console.log('Error : ', error);
                            _this.toasterService.showToaster(new Toaster({
                                type: ToasterType.WARNING,
                                message: "Error in fetching cities",
                            }));
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasicInfoComponent.prototype.getCityServices = function (cityControl, loadOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var city, restoringFromApi, cityId, response, services, _i, _a, service, skipMcFetch, e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        city = cityControl.value;
                        if (!city) {
                            return [2 /*return*/];
                        }
                        restoringFromApi = !!(loadOptions && loadOptions.serviceTypeIdsToRestore);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 5, 6, 7]);
                        this.services = [];
                        if (!restoringFromApi) {
                            this.basicInfoFormGroup.patchValue({ selectedService: '' });
                        }
                        cityId = city._id;
                        return [4 /*yield*/, this.sharedService.fetchServices(cityId).toPromise()];
                    case 2:
                        response = _b.sent();
                        services = response.data || [];
                        if (this.state == this.sharedService.STATE.EDIT) {
                            this.services = services.filter(function (dat) {
                                if (dat.service) {
                                    return dat.service = dat.service || [];
                                }
                            });
                        }
                        else {
                            this.services = services.filter(function (dat) {
                                if (dat.service && !_this.blockServicesForIncentiveCreation.has(dat.service._id)) {
                                    return dat.service = dat.service || [];
                                }
                            });
                        }
                        this.serviceNames = [];
                        for (_i = 0, _a = this.services; _i < _a.length; _i++) {
                            service = _a[_i];
                            if (service._id && service.service && service.service.name) {
                                this.serviceNames[service._id] = service.service.name;
                            }
                        }
                        if (restoringFromApi) {
                            this.applyServiceSelectionFromIds(loadOptions.serviceTypeIdsToRestore);
                        }
                        skipMcFetch = loadOptions && loadOptions.skipMicroCorridorFetch;
                        if (!(this.getValues('isMCIncentive') && !skipMcFetch)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.fetchMicroCorridorsForCity()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        e_1 = _b.sent();
                        console.log(e_1);
                        this.toasterService.showToaster(new Toaster({
                            type: ToasterType.WARNING,
                            message: "Error in fetching city services",
                        }));
                        return [3 /*break*/, 7];
                    case 6:
                        this.loaderService.closeLoading();
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    BasicInfoComponent.prototype.getShifts = function (cityControl) {
        var _this = this;
        var city = cityControl.value;
        if (city) {
            city = [city];
            this.shifts = [];
            this.basicInfoFormGroup.patchValue({ selectedShift: [] });
            this.tempShifts = [];
            var count_1 = 0;
            var cityName = '';
            for (var i in city) {
                if (i) {
                    for (var index in this.cities) {
                        if (this.cities[index].displayName === city[i].displayName) {
                            cityName = city[i].displayName;
                            this.loaderService.openLoading();
                            this.sharedService.fetchShifts(cityName).subscribe(function (response) {
                                _this.loaderService.closeLoading();
                                count_1++;
                                _this.tempShifts.push(response['data']);
                                if (count_1 === city.length && city.length > 1) {
                                    _this.getIntersectionOfShifts(city.length);
                                }
                                else {
                                    _this.shifts = response['data'];
                                }
                            }, function (error) {
                                console.log('Error : ', error);
                                _this.toasterService.showToaster(new Toaster({
                                    type: ToasterType.WARNING,
                                    message: "Error in fetching shifts",
                                }));
                            });
                        }
                    }
                }
            }
        }
    };
    BasicInfoComponent.prototype.getIntersectionOfShifts = function (selectedCityCount) {
        var _this = this;
        this.shifts = [];
        var shiftMap = new Map();
        this.tempShifts.forEach(function (shifts) {
            shifts.forEach(function (shift) {
                if (shiftMap.has(shift)) {
                    shiftMap.set(shift, shiftMap.get(shift) + 1);
                }
                else {
                    shiftMap.set(shift, 1);
                }
            });
        });
        shiftMap.forEach(function (value, key) {
            if (value === selectedCityCount) {
                _this.shifts.push(key);
            }
        });
    };
    BasicInfoComponent.prototype.getIntersectionOfServices = function () {
        var _this = this;
        this.services = [];
        var serviceMap = {};
        this.tempServices.forEach(function (cities) {
            cities.forEach(function (cityService) {
                if (serviceMap[cityService.service._id]) {
                    serviceMap[cityService.service._id].push(cityService);
                }
                else {
                    serviceMap[cityService.service._id] = [cityService];
                }
                if (serviceMap[cityService.service._id].length === _this.tempServices.length) {
                    _this.services.push(serviceMap[cityService.service._id][0]);
                }
            });
        });
        for (var svc in this.services) {
            this.serviceNames[this.services[svc]._id] = this.services[svc].service.name;
        }
    };
    BasicInfoComponent.prototype.checkPriority = function () {
        if (this.getValues('priority') && this.getValues('priority') < 0) {
            this.toasterService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: "Priority should be greater than 0",
            }));
        }
    };
    BasicInfoComponent.prototype.checkRuleObj = function () {
        if (this.ruleObj['city'] && this.ruleObj['service'] && !this.getValues('isHHIncentive')) {
            this.getRules();
        }
    };
    BasicInfoComponent.prototype.serviceSelected = function (skipMcCorridorReset) {
        this.enforceLogisticsV2Eligibility();
        if (this.getValues('selectedService').length > 0) {
            this.ruleObj['service'] = true;
            if (this.getValues('isMCIncentive') && !skipMcCorridorReset) {
                this.fetchMicroCorridorsForCity({ dropMissingSelection: true });
            }
        }
        else {
            this.rules = [];
            this.ruleObj['service'] = false;
            if (this.getValues('isMCIncentive')) {
                this.microCorridors = [];
                this.microCorridorsError = true;
                if (!this.NOT_EDITABLE.selectedMicroCorridorId) {
                    this.basicInfoFormGroup.patchValue({ selectedMicroCorridorId: null });
                }
            }
        }
    };
    BasicInfoComponent.prototype.enableAdhocIncentiveDisplayName = function () {
        this.adHocIncentive = this.isAdhocIncentive();
        if (this.adHocIncentive) {
            this.basicInfoFormGroup.addControl("incentiveDisplayName", this.incentiveDisplayNameFormControl);
        }
        else {
            this.basicInfoFormGroup.removeControl('incentiveDisplayName');
        }
    };
    BasicInfoComponent.prototype.isLogisticsV2 = function () {
        return isLogisticsV2Version(this.getValues('incentiveVersion'));
    };
    BasicInfoComponent.prototype.logisticsV2Config = function () {
        return resolveLogisticsV2IncentiveConfig(environment);
    };
    BasicInfoComponent.prototype.logisticsV2AllowedIncentiveTypes = function () {
        return this.logisticsV2Config().allowedIncentiveTypes;
    };
    BasicInfoComponent.prototype.selectableIncentiveTypes = function () {
        if (!this.isLogisticsV2()) {
            return this.incentiveType;
        }
        var allowed = new Set(this.logisticsV2AllowedIncentiveTypes());
        return this.incentiveType.filter(function (type) { return allowed.has(type); });
    };
    BasicInfoComponent.prototype.logisticsV2TypesHelp = function () {
        return formatLogisticsV2AllowedIncentiveTypes(this.logisticsV2AllowedIncentiveTypes());
    };
    BasicInfoComponent.prototype.incentiveVersionNote = function () {
        var _this = this;
        var selected = this.incentiveVersionOptions.find(function (o) { return o.value === _this.getValues('incentiveVersion'); });
        return selected ? selected.note : '';
    };
    /** Edit and duplicate keep the source version only — v1 and v2 cannot be switched. */
    BasicInfoComponent.prototype.incentiveVersionOptionsForForm = function () {
        var locked = this.lockedIncentiveVersion();
        if (locked) {
            return this.incentiveVersionOptions.filter(function (o) { return o.value === locked; });
        }
        return this.incentiveVersionOptions;
    };
    BasicInfoComponent.prototype.lockedIncentiveVersion = function () {
        if (this.state !== this.sharedService.STATE.EDIT
            && this.state !== this.sharedService.STATE.DUPLICATE) {
            return null;
        }
        if (!this.defaultValue) {
            return null;
        }
        return resolveIncentiveVersionFromApi(this.defaultValue);
    };
    BasicInfoComponent.prototype.onIncentiveVersionChange = function () {
        var locked = this.lockedIncentiveVersion();
        if (locked) {
            if (this.getValues('incentiveVersion') !== locked) {
                this.basicInfoFormGroup.patchValue({
                    incentiveVersion: locked,
                    payoutType: locked === INCENTIVE_VERSION_V2
                        ? (this.defaultValue.payoutType || 'Immediate')
                        : null,
                });
            }
            return;
        }
        if (!this.isLogisticsV2()) {
            this.basicInfoFormGroup.patchValue({
                payoutType: null,
                isMCIncentive: false,
                selectedMicroCorridorId: null,
            });
            this.clearMicroCorridorState();
            return;
        }
        if (!this.getValues('payoutType')) {
            this.basicInfoFormGroup.patchValue({ payoutType: 'Immediate' });
        }
        this.clearHHIncentiveForLogisticsV2();
        this.enforceV2IncentiveTypeConstraints();
        this.enforceLogisticsV2Eligibility();
    };
    BasicInfoComponent.prototype.showHHIncentiveOption = function () {
        if (!this.isLogisticsV2()) {
            return true;
        }
        return !isLogisticsV2FeatureEnabled(environment, 'hhOnV1Only');
    };
    BasicInfoComponent.prototype.clearHHIncentiveForLogisticsV2 = function () {
        if (!this.isLogisticsV2() || !isLogisticsV2FeatureEnabled(environment, 'hhOnV1Only')) {
            return;
        }
        if (!this.getValues('isHHIncentive')) {
            return;
        }
        this.basicInfoFormGroup.patchValue({ isHHIncentive: false });
        this.basicInfoFormGroup.get('selectedRule').enable();
    };
    BasicInfoComponent.prototype.enforceV2IncentiveTypeConstraints = function () {
        if (!this.isLogisticsV2()) {
            return;
        }
        var allowed = this.logisticsV2AllowedIncentiveTypes();
        var incentiveType = this.getValues('selectedIncentive');
        if (!incentiveType || isLogisticsV2IncentiveTypeAllowed(incentiveType, allowed)) {
            return;
        }
        var fallback = allowed[0];
        this.toasterService.showToaster(new Toaster({
            type: ToasterType.WARNING,
            message: "Incentive version v2 supports " + this.logisticsV2TypesHelp() + ". Type set to " + fallback + ".",
        }));
        this.basicInfoFormGroup.patchValue({ selectedIncentive: fallback });
    };
    BasicInfoComponent.prototype.incentiveTypeSelected = function () {
        var today = moment().utcOffset("+0530").toDate();
        this.enforceV2IncentiveTypeConstraints();
        this.basicInfoFormGroup.get('isHHIncentive').enable();
        this.basicInfoFormGroup.get('isMCIncentive').enable();
        if (!this.isDailyIncentive()) {
            this.basicInfoFormGroup.get('isHHIncentive').setValue(false);
            this.basicInfoFormGroup.get('isHHIncentive').disable();
            this.basicInfoFormGroup.get('isMCIncentive').setValue(false);
            this.basicInfoFormGroup.get('isMCIncentive').disable();
            this.clearMicroCorridorState();
        }
        this.enableAdhocIncentiveDisplayName();
        if (this.isAdhocIncentive()) {
            this.basicInfoFormGroup.get('fromDate').setValue(today);
            this.basicInfoFormGroup.get('toDate').setValue(today);
            this.basicInfoFormGroup.get('fromDate').disable();
            this.basicInfoFormGroup.get('toDate').disable();
            this.basicInfoFormGroup.get('priority').setValue(0);
            this.enforceLogisticsV2Eligibility();
            return;
        }
        if (!this.NOT_EDITABLE.fromDate)
            this.basicInfoFormGroup.get('fromDate').enable();
        if (!this.NOT_EDITABLE.toDate)
            this.basicInfoFormGroup.get('toDate').enable();
        if (this.NOT_EDITABLE.isHHIncentive) {
            this.basicInfoFormGroup.get('isHHIncentive').disable();
        }
        if (this.NOT_EDITABLE.isMCIncentive) {
            this.basicInfoFormGroup.get('isMCIncentive').disable();
        }
        if (this.NOT_EDITABLE.selectedMicroCorridorId) {
            this.basicInfoFormGroup.get('selectedMicroCorridorId').disable();
        }
        else {
            this.basicInfoFormGroup.get('selectedMicroCorridorId').enable();
        }
        this.enforceLogisticsV2Eligibility();
    };
    BasicInfoComponent.prototype.isDailyIncentive = function () {
        var selectedType = this.getValues('selectedIncentive') || [];
        return selectedType.includes('Daily');
    };
    BasicInfoComponent.prototype.isAdhocIncentive = function () {
        var selectedType = this.getValues('selectedIncentive') || [];
        return selectedType.includes('Adhoc');
    };
    BasicInfoComponent.prototype.shiftSelected = function () {
        if (this.getValues('selectedShift').length > 0) {
            this.ruleObj['shift'] = true;
        }
        else {
            this.rules = [];
            this.ruleObj['shift'] = false;
        }
    };
    BasicInfoComponent.prototype.getRules = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var shift, service, city, userType, serviceId, cityId, selectedCity, selectedService, selectedShift, cityIndex, serviceIndex, response, result, index, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loaderService.openLoading();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        shift = void 0, service = void 0, city = void 0, userType = 'rider';
                        serviceId = [], cityId = [];
                        selectedCity = this.getValues('selectedCity');
                        selectedCity = [selectedCity];
                        selectedService = this.getValues('selectedService');
                        selectedShift = this.getValues('selectedShift');
                        for (cityIndex in selectedCity) {
                            if (selectedCity[cityIndex]) {
                                cityId.push(selectedCity[cityIndex]._id);
                            }
                        }
                        for (serviceIndex in selectedService) {
                            if (selectedService[serviceIndex]) {
                                serviceId.push(selectedService[serviceIndex]._id);
                            }
                        }
                        shift = selectedShift.join(',');
                        city = cityId.join(',');
                        service = serviceId.join(',');
                        return [4 /*yield*/, this.sharedService.fetchRules(city, service, shift, userType).toPromise()];
                    case 2:
                        response = _b.sent();
                        this.rules = [];
                        result = response['data'].selectors;
                        this.ruleSelector = response['data'].selectors;
                        for (index in result) {
                            if (this.rules.indexOf(result[index].name) === -1) {
                                this.rules.push(result[index].name);
                            }
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        _a = _b.sent();
                        this.toasterService.showToaster(new Toaster({
                            type: ToasterType.WARNING,
                            message: "Error in fetching selectors",
                        }));
                        return [3 /*break*/, 5];
                    case 4:
                        this.loaderService.closeLoading();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    BasicInfoComponent.prototype.getValues = function (name) {
        return this.basicInfoFormGroup.get(name).value;
    };
    BasicInfoComponent.prototype.errorMessage = function (message) {
        this.toasterService.showToaster(new Toaster({
            type: ToasterType.WARNING,
            message: message,
        }));
    };
    BasicInfoComponent.prototype.getServiceName = function (service) {
        this.serviceType = resolveServiceDetailIdsFromSelection(service);
    };
    BasicInfoComponent.prototype.goBack = function () {
        this.router.navigate(['/incentives']);
    };
    BasicInfoComponent.prototype.formatData = function () {
        var _this = this;
        var fromDate = this.getValues('fromDate');
        var toDate = this.getValues('toDate');
        var startDate = this.datePipe.transform(fromDate, 'yyyy-MM-dd');
        var endDate = this.datePipe.transform(toDate, 'yyyy-MM-dd');
        var formattedCurrentDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');
        if (!this.getValues('selectedIncentive')) {
            this.errorMessage("Select the type of incentive.");
            return;
        }
        if (!this.getValues('selectedSegment')) {
            this.errorMessage("Select the type of Segment.");
            return;
        }
        if (!this.getValues('incentiveName')) {
            this.errorMessage("Enter the incentive name.");
            return;
        }
        if (!this.getValues('identifier')) {
            this.errorMessage("Enter the identifier.");
            return;
        }
        if (this.state != this.sharedService.STATE.EDIT) {
            if (this.basicInfoFormGroup.get('incentiveName').invalid) {
                this.errorMessage("Only alphanumeric characters allowed for Incentive name.");
                return;
            }
            if (this.basicInfoFormGroup.get('identifier').invalid) {
                this.errorMessage("Only alphanumeric characters allowed for Identifier.");
                return;
            }
        }
        if (this.adHocIncentive && !this.getValues('incentiveDisplayName')) {
            this.errorMessage("Provide a display name for the incentive.");
            return;
        }
        if (!this.getValues('selectedCity')) {
            this.errorMessage("You need to select a city.");
            return;
        }
        if (!this.getValues('selectedService')) {
            this.errorMessage("You need to select at least one service.");
            return;
        }
        if (this.getValues('isMCIncentive') && this.hasUserSelectorSelected()) {
            this.errorMessage('Micro-corridor sign-in and User Selector cannot be used together.');
            return;
        }
        if (!this.getValues('isHHIncentive') && !this.getValues('isMCIncentive') && !this.hasUserSelectorSelected()) {
            this.errorMessage("Select a 'User Selector' or enable MC sign-in incentive.");
            return;
        }
        if (this.getValues('isMCIncentive')) {
            if (!isLogisticsV2Version(this.getValues('incentiveVersion'))) {
                this.errorMessage('Micro-corridor incentives require incentive version v2.');
                return;
            }
            if (this.getValues('payoutType') !== 'Deferred') {
                this.errorMessage('Micro-corridor incentives require payout type Deferred.');
                return;
            }
            if (!this.getValues('selectedMicroCorridorId')) {
                this.errorMessage('Select a micro-corridor for this incentive.');
                return;
            }
        }
        if (!this.minDate) {
            this.errorMessage("Provide the start date of the incentive.");
            return;
        }
        if (!this.maxDate) {
            this.errorMessage("Provide the end date of the incentive");
            return;
        }
        if (this.state != this.sharedService.STATE.EDIT && (endDate < startDate || startDate < formattedCurrentDate)) {
            this.errorMessage("You cannot create an incentive in the past.");
            return;
        }
        if (!this.getValues('priority') && this.getValues('selectedIncentive') !== 'Adhoc') {
            this.errorMessage("You need to provide a priority for the incentive.");
            return;
        }
        this.getServiceName(this.getValues('selectedService'));
        var cities = [];
        var cityValue = this.getValues('selectedCity');
        if (!(cityValue instanceof Array)) {
            cityValue = [cityValue];
        }
        var serviceValue = this.getValues('selectedService');
        for (var index in cityValue) {
            if (cityValue[index]) {
                cities.push(cityValue[index].displayName);
            }
        }
        var ruleSelectorId = this.getSelectedRuleSelectorId();
        if (this.getValues('selectedIncentive').includes('Weekly') && fromDate.getDay() !== 1) {
            this.basicInfoFormGroup.get('fromDate').setValue('');
            this.toasterService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: "Start date should be monday",
            }));
            return;
        }
        if (this.getValues('selectedIncentive').includes('Weekly') && toDate.getDay() !== 0) {
            this.basicInfoFormGroup.get('toDate').setValue('');
            this.toasterService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: "End date should be sunday",
            }));
            return;
        }
        var incentiveVersion = this.getValues('incentiveVersion') || INCENTIVE_VERSION_V1;
        if (isLogisticsV2Version(incentiveVersion)) {
            var incentiveType = this.getValues('selectedIncentive');
            var allowed = this.logisticsV2AllowedIncentiveTypes();
            if (!isLogisticsV2IncentiveTypeAllowed(incentiveType, allowed)) {
                this.errorMessage("Incentive version v2 supports " + formatLogisticsV2AllowedIncentiveTypes(allowed) + ".");
                return;
            }
            if (!this.getValues('payoutType')) {
                this.errorMessage('Payout type is required for incentive version v2.');
                return;
            }
        }
        var data = {
            incentiveName: this.state == this.sharedService.STATE.EDIT ? this.defaultValue.incentiveName : this.buildFinalIncentiveName(),
            incentiveDisplayName: this.adHocIncentive ? this.getValues('incentiveDisplayName') : null,
            incentiveType: this.getValues('selectedIncentive'),
            incentiveVersion: incentiveVersion,
            payoutType: isLogisticsV2Version(incentiveVersion) ? this.getValues('payoutType') : null,
            city: cities,
            isCancellationLimitEnabledForCity: this.isCancellationLimitEnabledForCity,
            isMaxOrderDistanceEnabledForCity: this.isMaxOrderDistanceEnabledForCity,
            service: this.serviceType,
            serviceIdsForConfig: resolveGlobalServiceIdsFromSelection(serviceValue),
            shift: this.getValues('selectedShift'),
            ruleName: this.getValues('selectedRule'),
            ruleId: ruleSelectorId,
            startDate: startDate,
            endDate: endDate,
            priority: this.getValues('priority') || 0,
            serviceNames: this.serviceType.map(function (service) { return _this.serviceNames[service]; }),
            submit: false,
            userSelectorCount: this.selectedRuleUserCount && this.selectedRuleUserCount.count,
            isHHIncentive: this.getValues('isHHIncentive'),
            isMCIncentive: this.getValues('isMCIncentive'),
            microCorridorId: this.getValues('isMCIncentive')
                ? this.getValues('selectedMicroCorridorId')
                : null,
            microCorridorName: this.resolveSelectedMicroCorridorName(),
        };
        return data;
    };
    BasicInfoComponent.prototype.passBasicInfo = function () {
        var _this = this;
        this.nextClicked = true;
        var higherPriorityHHIncentives;
        var data = this.formatData();
        if (!data) {
            return;
        }
        if (this.getValues("isHHIncentive") && this.state != this.sharedService.STATE.EDIT) {
            this.incentiveService.fetchIncentiveData({
                "filters": {
                    "cities": data.city,
                    "serviceType": data.service,
                    "types": [
                        "Daily"
                    ],
                    "startDate": data.startDate,
                    "endDate": data.startDate,
                    "active": true,
                    "isHHIncentive": true,
                }
            }).subscribe(function (res) {
                higherPriorityHHIncentives = res.filter(function (incentive) { return _this.getValues('priority') <= incentive.priority; });
                if (higherPriorityHHIncentives.length > 0) {
                    _this.errorPopupIncentives = higherPriorityHHIncentives;
                    _this.dialog.open(_this.HHIncentiveAlertDialog);
                }
                else if (data) {
                    _this.basicInfo.emit(data);
                }
            });
        }
        else if (data) {
            this.basicInfo.emit(data);
        }
    };
    BasicInfoComponent.prototype.checkCityEnabledForCancellationLimit = function (data) {
        if (environment.cancellationLimitEnabledCities.includes('All')) {
            this.isCancellationLimitEnabledForCity = true;
        }
        else if (data && environment.cancellationLimitEnabledCities.includes(data._id)) {
            this.isCancellationLimitEnabledForCity = true;
        }
        else {
            this.isCancellationLimitEnabledForCity = false;
        }
    };
    BasicInfoComponent.prototype.checkCityEnabledForMaxOrderDistance = function (data) {
        if (environment.maxOrderDistanceEnabledCities.includes('All')) {
            this.isMaxOrderDistanceEnabledForCity = true;
        }
        else if (data && environment.maxOrderDistanceEnabledCities.includes(data._id)) {
            this.isMaxOrderDistanceEnabledForCity = true;
        }
        else {
            this.isMaxOrderDistanceEnabledForCity = false;
        }
    };
    BasicInfoComponent.prototype.fetchRequiredDetails = function () {
        this.getCityServices(this.basicInfoFormGroup.get('selectedCity'));
        this.getShifts(this.basicInfoFormGroup.get('selectedCity'));
        this.checkCityEnabledForCancellationLimit(this.basicInfoFormGroup.get('selectedCity').value);
        this.checkCityEnabledForMaxOrderDistance(this.basicInfoFormGroup.get('selectedCity').value);
        this.enforceLogisticsV2Eligibility();
    };
    BasicInfoComponent.prototype.getSelectedRuleSelectorId = function () {
        for (var index in this.ruleSelector) {
            if (this.ruleSelector[index].name === this.getValues('selectedRule')) {
                return this.ruleSelector[index]._id;
            }
        }
        return "";
    };
    BasicInfoComponent.prototype.hasUserSelectorSelected = function () {
        var rule = this.getValues('selectedRule');
        return rule != null && String(rule).trim().length > 0;
    };
    BasicInfoComponent.prototype.showUserSelectorOption = function () {
        return !this.getValues('isMCIncentive');
    };
    BasicInfoComponent.prototype.ruleSelected = function () {
        var _this = this;
        this.selectedRuleUserCount = { loaded: false };
        var selectedRule = this.getSelectedRuleSelectorId();
        if (!selectedRule) {
            this.selectedRuleUserCount = null;
            return;
        }
        if (!this.NOT_EDITABLE.isMCIncentive && this.getValues('isMCIncentive')) {
            this.basicInfoFormGroup.patchValue({
                isMCIncentive: false,
                selectedMicroCorridorId: null,
            });
            this.clearMicroCorridorState();
        }
        this.sharedService.getUserSelectorDetails(selectedRule)
            .subscribe(function (response) {
            _this.selectedRuleUserCount = { loaded: true, count: response.userCount };
        });
    };
    BasicInfoComponent.prototype.HHIncentiveChecked = function () {
        if (this.getValues('isHHIncentive')) {
            this.basicInfoFormGroup.patchValue({ isMCIncentive: false, selectedMicroCorridorId: null });
            this.clearMicroCorridorState();
            this.basicInfoFormGroup.get('selectedRule').disable();
            this.basicInfoFormGroup.patchValue({ selectedRule: null });
            return;
        }
        this.basicInfoFormGroup.get('selectedRule').enable();
    };
    BasicInfoComponent.prototype.showLogisticsV2BasicInfoUi = function () {
        if (this.NOT_EDITABLE.incentiveVersion && this.isLogisticsV2()) {
            return true;
        }
        if (!this.logisticsV2Config().enabled) {
            return false;
        }
        if (!isLogisticsV2FeatureEnabled(environment, 'versionPayoutUi')) {
            return false;
        }
        if (!this.basicInfoPrerequisitesMet()) {
            return false;
        }
        return this.logisticsV2ServiceAllowlistMet();
    };
    BasicInfoComponent.prototype.basicInfoPrerequisitesMet = function () {
        var incentiveName = this.getValues('incentiveName');
        var selectedService = this.getValues('selectedService');
        return !!this.getValues('selectedIncentive')
            && !!this.getValues('selectedSegment')
            && incentiveName != null && String(incentiveName).trim().length > 0
            && !!this.getValues('selectedCity')
            && selectedService && selectedService.length > 0;
    };
    BasicInfoComponent.prototype.logisticsV2ServiceAllowlistMet = function () {
        return isLogisticsV2CreateUiEnabledForServices(environment, this.getValues('selectedService'));
    };
    BasicInfoComponent.prototype.enforceLogisticsV2Eligibility = function () {
        if (this.NOT_EDITABLE.incentiveVersion) {
            return;
        }
        if (this.showLogisticsV2BasicInfoUi()) {
            return;
        }
        if (isLogisticsV2Version(this.getValues('incentiveVersion'))) {
            this.basicInfoFormGroup.patchValue({
                incentiveVersion: INCENTIVE_VERSION_V1,
                payoutType: null,
                isMCIncentive: false,
                selectedMicroCorridorId: null,
            });
            this.clearMicroCorridorState();
            this.basicInfoFormGroup.get('selectedRule').enable();
            return;
        }
        if (this.getValues('isMCIncentive')) {
            this.basicInfoFormGroup.patchValue({
                isMCIncentive: false,
                selectedMicroCorridorId: null,
            });
            this.clearMicroCorridorState();
            this.basicInfoFormGroup.get('selectedRule').enable();
        }
    };
    BasicInfoComponent.prototype.showMCIncentiveOption = function () {
        if (!isLogisticsV2FeatureEnabled(environment, 'mcSignIn')) {
            return false;
        }
        if (!this.showLogisticsV2BasicInfoUi() || !this.mcSignInTypeEligible()) {
            return false;
        }
        if (this.NOT_EDITABLE.isMCIncentive) {
            return true;
        }
        if (this.hasUserSelectorSelected()) {
            return false;
        }
        return this.logisticsV2ServiceAllowlistMet();
    };
    BasicInfoComponent.prototype.mcSignInTypeEligible = function () {
        return this.isDailyIncentive() && this.isLogisticsV2();
    };
    BasicInfoComponent.prototype.microCorridorOptionLabel = function (mc) {
        return formatMicroCorridorOptionLabel(mc);
    };
    BasicInfoComponent.prototype.MCIncentiveChecked = function () {
        if (this.getValues('isMCIncentive')) {
            this.basicInfoFormGroup.patchValue({ isHHIncentive: false });
            this.basicInfoFormGroup.patchValue({
                incentiveVersion: INCENTIVE_VERSION_V2,
                payoutType: 'Deferred',
                selectedRule: null,
            });
            this.basicInfoFormGroup.get('selectedRule').disable();
            this.selectedRuleUserCount = null;
            var city = this.getValues('selectedCity');
            if (city && city._id) {
                this.fetchMicroCorridorsForCity();
            }
            return;
        }
        this.basicInfoFormGroup.get('selectedRule').enable();
        this.clearMicroCorridorState();
    };
    BasicInfoComponent.prototype.resolveSelectedMicroCorridorName = function () {
        var mcId = this.getValues('selectedMicroCorridorId');
        if (!mcId) {
            return null;
        }
        var mc = this.microCorridors.find(function (c) { return c.id === mcId; });
        if (mc && mc.name && String(mc.name).trim()) {
            return String(mc.name).trim();
        }
        if (mc && mc.displayLabel) {
            return mc.displayLabel.replace(/\s*\[[^\]]*\]\s*$/, '').trim() || null;
        }
        return null;
    };
    /** After a service change, drop a corridor the new service set no longer returns. */
    BasicInfoComponent.prototype.dropMicroCorridorIfMissingFromList = function () {
        var mcId = this.getValues('selectedMicroCorridorId');
        if (!mcId || this.microCorridors.some(function (c) { return c.id === mcId; })) {
            return;
        }
        if (this.NOT_EDITABLE.selectedMicroCorridorId) {
            return;
        }
        this.basicInfoFormGroup.patchValue({ selectedMicroCorridorId: null });
    };
    BasicInfoComponent.prototype.ensureSelectedMicroCorridorInList = function () {
        var mcId = this.getValues('selectedMicroCorridorId');
        if (!mcId || this.microCorridors.some(function (c) { return c.id === mcId; })) {
            return;
        }
        var fromDefault = this.defaultValue && this.defaultValue.microCorridorName;
        var name = fromDefault && String(fromDefault).trim()
            ? String(fromDefault).trim()
            : '';
        if (!name) {
            return;
        }
        var stub = {
            id: String(mcId),
            name: name,
        };
        this.microCorridors = attachMicroCorridorDisplayLabels([stub].concat(this.microCorridors));
    };
    BasicInfoComponent.prototype.shouldEnsureSelectedMicroCorridorInList = function () {
        return this.state === this.sharedService.STATE.EDIT
            || this.state === this.sharedService.STATE.DUPLICATE;
    };
    BasicInfoComponent.prototype.clearMicroCorridorState = function () {
        this.microCorridors = [];
        this.microCorridorsError = false;
        this.microCorridorsLoading = false;
        this.basicInfoFormGroup.patchValue({ selectedMicroCorridorId: null });
    };
    BasicInfoComponent.prototype.loadMicroCorridorsAfterEditPrefill = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.getValues('isMCIncentive')) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.fetchMicroCorridorsForCity()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasicInfoComponent.prototype.fetchMicroCorridorsForCity = function (options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var city, serviceDetailIds, modeId, res, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        city = this.getValues('selectedCity');
                        if (!city || !city._id) {
                            this.microCorridors = [];
                            this.microCorridorsError = false;
                            this.microCorridorsLoading = false;
                            return [2 /*return*/];
                        }
                        serviceDetailIds = resolveServiceDetailIdsForMcListing(this.getValues('selectedService'), this.services);
                        if (serviceDetailIds.length === 0) {
                            this.microCorridors = [];
                            this.microCorridorsError = true;
                            this.microCorridorsErrorMessage = this.microCorridorsEmptyMessage;
                            this.microCorridorsLoading = false;
                            if (options && options.dropMissingSelection) {
                                this.dropMicroCorridorIfMissingFromList();
                            }
                            return [2 /*return*/];
                        }
                        modeId = resolveModeIdForMcListing(this.getValues('selectedService'), this.services);
                        if (!modeId) {
                            this.microCorridors = [];
                            this.microCorridorsError = true;
                            this.microCorridorsErrorMessage = this.microCorridorsModeMissingMessage;
                            this.microCorridorsLoading = false;
                            if (options && options.dropMissingSelection) {
                                this.dropMicroCorridorIfMissingFromList();
                            }
                            return [2 /*return*/];
                        }
                        this.microCorridorsLoading = true;
                        this.microCorridorsError = false;
                        this.microCorridorsErrorMessage = '';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.sharedService.fetchMicroCorridors({
                                cityId: String(city._id),
                                serviceDetailIds: serviceDetailIds,
                                modeId: modeId,
                            }).toPromise()];
                    case 2:
                        res = _a.sent();
                        this.microCorridors = parseMicroCorridorsApiResponse(res);
                        if (options && options.dropMissingSelection) {
                            this.dropMicroCorridorIfMissingFromList();
                        }
                        else if (this.shouldEnsureSelectedMicroCorridorInList()) {
                            this.ensureSelectedMicroCorridorInList();
                        }
                        if (this.microCorridors.length === 0) {
                            this.microCorridorsError = true;
                            this.microCorridorsErrorMessage = this.microCorridorsEmptyMessage;
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        e_2 = _a.sent();
                        this.microCorridors = [];
                        this.microCorridorsError = true;
                        this.microCorridorsErrorMessage = this.microCorridorsEmptyMessage;
                        this.toasterService.showToaster(new Toaster({
                            type: ToasterType.WARNING,
                            message: 'Could not load micro-corridors for this city.',
                        }));
                        return [3 /*break*/, 5];
                    case 4:
                        this.microCorridorsLoading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    BasicInfoComponent.prototype.segmentSelected = function () {
        if (this.getValues("selectedSegment") != "CUSTOM") {
            this.basicInfoFormGroup.patchValue({
                incentiveName: this.getValues("selectedSegment")
            });
            this.basicInfoFormGroup.get('incentiveName').disable();
        }
        else {
            this.basicInfoFormGroup.get('incentiveName').enable();
        }
        this.enforceLogisticsV2Eligibility();
    };
    BasicInfoComponent.prototype.buildCityShortName = function () {
        if (this.basicInfoFormGroup.get('selectedCity').value != null) {
            return this.basicInfoFormGroup.get('selectedCity').value.shortName.toUpperCase();
        }
    };
    BasicInfoComponent.prototype.buildServiceName = function () {
        var services = this.basicInfoFormGroup.get('selectedService').value;
        if (services.length > 0) {
            var serviceNames = services[0].service.name.toUpperCase();
            for (var index = 1; index < services.length; index++) {
                serviceNames += " " + services[index].service.name.toUpperCase();
            }
            return serviceNames;
        }
    };
    BasicInfoComponent.prototype.buildIncentiveAndSegmentName = function () {
        if (!this.basicInfoFormGroup.get('selectedSegment').value) {
            return;
        }
        else if (this.basicInfoFormGroup.get('selectedSegment').value && this.basicInfoFormGroup.get('incentiveName').value && this.basicInfoFormGroup.get('selectedSegment').value == "CUSTOM") {
            return this.basicInfoFormGroup.get('selectedSegment').value.trim().toUpperCase() + " " + this.basicInfoFormGroup.get('incentiveName').value.trim().toUpperCase();
        }
        else {
            return this.basicInfoFormGroup.get('selectedSegment').value.trim().toUpperCase();
        }
    };
    BasicInfoComponent.prototype.buildFormatedFromDate = function () {
        if (this.basicInfoFormGroup.get('fromDate').value != "") {
            var fromDate = this.basicInfoFormGroup.get('fromDate').value;
            return this.datePipe.transform(fromDate, 'ddMMyyyy').trim();
        }
    };
    BasicInfoComponent.prototype.buildFormatedToDate = function () {
        if (this.basicInfoFormGroup.get('toDate').value != "") {
            var toDate = this.basicInfoFormGroup.get('toDate').value;
            return this.datePipe.transform(toDate, 'ddMMyyyy').trim();
        }
    };
    BasicInfoComponent.prototype.buildIncentiveType = function () {
        if (this.basicInfoFormGroup.get('selectedIncentive').value != null)
            return this.basicInfoFormGroup.get('selectedIncentive').value.toUpperCase();
    };
    BasicInfoComponent.prototype.buildIdentifier = function () {
        if (this.basicInfoFormGroup.get('identifier').value != null)
            return this.basicInfoFormGroup.get('identifier').value.trim().toUpperCase();
    };
    BasicInfoComponent.prototype.buildRuleName = function () {
        if (this.basicInfoFormGroup.get('selectedRule').value != null) {
            return this.basicInfoFormGroup.get('selectedRule').value.trim();
        }
        else {
            return "";
        }
    };
    BasicInfoComponent.prototype.buildFinalIncentiveName = function () {
        return "MANUAL_" + this.buildCityShortName() + "_" + this.buildServiceName() + "_" + this.buildIncentiveAndSegmentName() + "_" + this.buildFormatedFromDate() + "_" + this.buildFormatedToDate() + "_" + this.buildIncentiveType() + "_" + this.buildIdentifier() + "_" + this.buildRuleName();
    };
    BasicInfoComponent.prototype.openUserSelectorPage = function () {
        this.basicInfoFormGroup.get('selectedRule').setValue(null);
        window.open(environment.userSelectorCreationPageLink);
    };
    return BasicInfoComponent;
}());
export { BasicInfoComponent };
